import { apiClient } from 'modules/apiClient';
import { meteoModule } from 'modules/api';

import {
  LatestModelTimesApiResponse,
  MeteoModelMetadataApiResponse,
} from '../types';

export const getModelMetadataApi = async (
  link: string,
): Promise<MeteoModelMetadataApiResponse> => {
  try {
    const response = await apiClient.get(link);
    return response.data;
  } catch (error) {
    return {
      time: '',
      maxLat: 0,
      maxLon: 0,
      minLat: 0,
      minLon: 0,
    };
  }
};

export const getLatestModelTimesApi =
  async (): Promise<LatestModelTimesApiResponse | null> => {
    try {
      const response = await apiClient.get(meteoModule.LatestTimes);
      return response.data;
    } catch (error) {
      return null;
    }
  };
